import { useState, useEffect } from 'react';
import { legacyPolicyNumberHandler } from '../helpers/paymentHelper';
// fetch outstanding payment records of each policy
const useFetchOutstandingPayments = (petDetails, petDetailsLoading, trigger, auth0Token, isV3ApiEnabled) => {
  const [outstandingPaymentDetails, setOutstandingPaymentDetails] = useState([]);
  useEffect(() => {
    if (!petDetailsLoading && isV3ApiEnabled !== undefined && (!isV3ApiEnabled || auth0Token)) {
      const fetchOutstandingPayment = async () => {
        const petDetailsList = petDetails || [];
        const promises = petDetailsList.map(({ FullPolicyNumber, PartnerNumber }) => {
          return trigger({
            policyNumber: legacyPolicyNumberHandler(FullPolicyNumber),
            partnerNumber: PartnerNumber,
            auth0Token,
            isV3ApiEnabled
          });
        });
        const allResponses = await Promise.all(promises);
        const dataResponses = allResponses?.map((res) => res.data);
        setOutstandingPaymentDetails(dataResponses);
      };
      fetchOutstandingPayment();
    }
  }, [petDetails, petDetailsLoading, trigger, auth0Token, isV3ApiEnabled]);
  return outstandingPaymentDetails;
};

export { useFetchOutstandingPayments };
